import React, { useState, useEffect } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';

// Components
import ContratoIdentificacao from './Components/ContratoIdentificacao.jsx';
import ContratoFases from './Components/ContratoFases.jsx';
import { showMessage } from 'helpers/message.js';
import contrato_api from '../../../api/contrato_api.js';
import ConfiguracaoFiscalizacao from './Components/ConfiguracaoFiscalizacao.jsx';
import SecoesFiscalizacao from './Components/SecoesFiscalizacao.jsx';

export default function AdicionarContrato({ contratoFicha, btnVoltar }) {
    //Estado de controle do loading
    const [show_loading, set_show_loading] = useState(false);

    //Estado de controle dos steps do contrato
    const [step_formulario, set_step_formulario] = useState(0);

    //Estado de controle dos dados do contrato
    const [contrato, set_contrato] = useState(contratoFicha ? contratoFicha : {});

    const loadContrato = () => {
        if (contrato.contrato_Id) {
            set_show_loading(true);
            contrato_api.getItem(contrato.contrato_Id).then(response => {
                if (response.status !== 200) {
                    showMessage("Aviso", response.message, 'error', null);
                    return;
                }
                set_contrato(response.data);
            }).finally(f => set_show_loading(false));
        }
    }
    useEffect(() => {
        loadContrato();
    }, []);
    return (
        <div className='content'>
            <div>
                <Button onClick={btnVoltar}>
                    <i className="fas fa-chevron-left"></i> Voltar
                </Button>
            </div>
            <Card>
                <CardHeader>
                    <h4 className="titleCard">+ Adicionar Contrato</h4>
                    <Nav justified tabs pills className="mr-auto">
                        <NavItem>
                            <NavLink active={step_formulario == 0} onClick={() => set_step_formulario(0)}>Identificação</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink active={step_formulario == 1} onClick={() => {
                                if (!contrato.contrato_Id) {
                                    showMessage("Aviso", "Salve os dados da identificação do contrato para cadastrar as fases", "warning", null);
                                    return;
                                }
                                set_step_formulario(1);
                            }}>Configuração de Fiscalização</NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink active={step_formulario == 2} onClick={() => {
                                if (!contrato.contrato_Id) {
                                    showMessage("Aviso", "Salve os dados da identificação do contrato para cadastrar as seções de fiscalização", "warning", null);
                                    return;
                                }
                                set_step_formulario(2);
                            }}>Seções de Fiscalização</NavLink>
                        </NavItem>
                        {/* <NavItem>
                            <NavLink active={step_formulario == 3} onClick={() => {
                                if (!contrato.contrato_Id) {
                                    showMessage("Aviso", "Salve os dados da identificação do contrato para cadastrar as fases", "warning", null);
                                    return;
                                }
                                set_step_formulario(3);
                            }}>Fases</NavLink>
                        </NavItem> */}
                    </Nav>
                </CardHeader>
                <CardBody>
                    {step_formulario == 0 && <ContratoIdentificacao contrato={contrato} set_contrato={set_contrato} />}
                    {step_formulario == 1 && <ConfiguracaoFiscalizacao contrato={contrato} set_contrato={set_contrato} loadContrato={loadContrato} />}
                    {step_formulario == 2 && <SecoesFiscalizacao contrato={contrato} />}
                    {/* {step_formulario == 3 && <ContratoFases contrato={contrato} loadContrato={loadContrato} />} */}
                </CardBody>
            </Card>
        </div>
    )
}